module.exports = __webpack_public_path__ + "static/media/nail_care.b3aa6186.jpg";